import { render } from "./MoveModal.vue?vue&type=template&id=25f8b05a"
import script from "./MoveModal.vue?vue&type=script&lang=js"
export * from "./MoveModal.vue?vue&type=script&lang=js"

import "./MoveModal.vue?vue&type=style&index=0&id=25f8b05a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__